import { useEffect, useRef } from 'react';
import { accountToday, type AccountInfo } from '@sl/core';
import { useClock } from '../clock/ClockProvider';

/** Refresh the server's account calendar after midnight, including tabs left open overnight. */
export function useAccountDayRollover(accounts: readonly AccountInfo[], refresh: () => void) {
  const clock = useClock();
  const lastAttempt = useRef('');
  useEffect(() => {
    function tick() {
      const changed = accounts
        .filter((a) => accountToday(clock.now(), a.timezone) !== a.today)
        .map((a) => `${a.id}:${accountToday(clock.now(), a.timezone)}`)
        .sort()
        .join('|');
      if (changed && changed !== lastAttempt.current) {
        lastAttempt.current = changed;
        refresh();
      }
    }
    tick();
    const timer = setInterval(tick, 60_000);
    return () => clearInterval(timer);
  }, [accounts, refresh, clock]);
}
